module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMxJREFUSA3tlm0KwjAMht+U4h08064wvIUIQ0SGiB+38AzilbzEWEyqG2P139L+aqDQj/VJSLKkhCOv0KEFYyNjDQshvEF4wOPgA7zHzoI7MtRQFmYH0aGWqzhUONFr/GjJpOFKrj+VTWiYA+tMtIQZ3f1xXXRgvJFBgUZc5es3G/sHlrAJe76hx9aGPKM43JO7SNO0DnrTpGld0nQW1XjppCiVNI39MtkpaTpxxv9p8lKRQUGG/+Ai5dq26Q/hcLh6fVpo9w/NP8Gz5QOzyFTZTKjqngAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-kcsl.png
// module id = 422
// module chunks = 2